import { Component, Inject } from '@angular/core';
import { Settings } from '../../data/models';
import { APP_SETTINGS } from '../../data/settings-data.provider';

@Component({
    selector: 'app-desktop-layout',
    template: `
    <div class="d-flex vh-100 w-100">
      <app-navbar>
        <a href="/" class="d-block p-3 link-dark text-decoration-none text-center" start>
          <img *ngIf="settings.shopLogoUrl; else defaultLogo" class="w-64px" alt="logo" [src]="generateLogoUrl()">
          <ng-template #defaultLogo>
            <img class="w-64px" alt="logo" src="//www.gravatar.com/avatar/db186c414506d0216edd201890a49853?d=mm&s=100">
          </ng-template>
        </a>
      </app-navbar>

      <div class="h-100 w-75 flex-grow-1 flex-shrink-1">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-alerts-container></app-alerts-container>
  `,
    styles: [`
    :host {
      display: block;
    }
  `],
    standalone: false
})
export class DesktopLayoutComponent {
  constructor(@Inject(APP_SETTINGS) public readonly settings: Settings) {}

  generateLogoUrl() {
    const baseUrl = 'https://img.versacommerce.io/resize=x120/canvas=0/++/';
    const logoUrl = this.settings.shopLogoUrl?.replace(/^https?:\/\//, '');
    return baseUrl + logoUrl;
  }
}